// @ts-expect-error TODO: bump the typescript-eslint stack in order to bump compilerOptions.lib ES version
if (typeof Promise.withResolvers !== 'function') {
  Object.defineProperty(Promise, 'withResolvers', {
    value: function () {
      // Your function logic here (preferably using 'this')
      let res, rej;
      const promise = new this(
        (resolve: (value: unknown) => void, reject: (reason?: any) => void) => {
          // 'this' is Promise or subclass
          res = resolve;
          rej = reject;
        },
      );
      return { promise, resolve: res, reject: rej };
    },
    writable: true,
    configurable: true,
    enumerable: false,
  });
}
